/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecordIdentityBatchRequest {
    getFixupPrototypeFunction() { return RecordIdentityBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<RecordIdentityBatchRequest>): RecordIdentityBatchRequest {
        let obj = Object.assign(new RecordIdentityBatchRequest(), model);
        RecordIdentityBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecordIdentityBatchRequest>): RecordIdentityBatchRequest {
        if (!model) return null;
        return RecordIdentityBatchRequest.newInstance(<RecordIdentityBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecordIdentityBatchRequest) {
        if (!obj) return;

        models.RecordIdentityBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecordIdentityBatchRequest): boolean {
        Object.setPrototypeOf(obj, RecordIdentityBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.ids) {
            for (let val of this.ids) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    ids: Array<models.RecordIdentity>;

}
